export default __webpack_public_path__ + "assets/report-analysis.e2f5918c.svg";